<template>
  <v-container
    class="fill-height justify-center"
    style="height: 90vh;"
    tag="section"
  >
    <v-row justify="center">
      <v-col cols="11" sm="8" md="6" lg="5" xl="5">
        <v-card class="elevation-6">
          <v-card-title class="pb-0">
            <v-btn color="secondary" text @click="$router.replace('/login')">
              <v-icon>mdi-chevron-left</v-icon>
              {{ $vuetify.lang.t('$vuetify.LOG_IN') }}
            </v-btn>
          </v-card-title>
          <v-col
            cols="12"
            class="d-flex align-center justify-center title text--secondary mb-6"
          >
            {{ $vuetify.lang.t('$vuetify.ENTER_PASSWORD') }}
          </v-col>
          <div class="pl-7 pb-7 pr-7 pl-sm-12 pb-sm-12 pr-sm-12">
            <v-form
              ref="form"
              v-model="valid"
              lazy-validation
              action="/dashboards/analytical"
            >
              <v-text-field
                :value="email"
                :label="$vuetify.lang.t('$vuetify.REGISTER.EMAIL')"
                disabled
                outlined
                type="email"
              ></v-text-field>
              <v-text-field
                v-model="password"
                :rules="passwordRules"
                :label="$vuetify.lang.t('$vuetify.ENTER_PASSWORD')"
                class="mb-2"
                required
                outlined
                type="password"
              ></v-text-field>
              <v-text-field
                v-model="repeatPassword"
                :rules="repeatPasswordRules"
                :label="$vuetify.lang.t('$vuetify.REPEAT_PASSWORD')"
                required
                outlined
                type="password"
              ></v-text-field>

              <span v-if="error" class="error--text">{{ error.message }}</span>
              <v-btn
                :disabled="!isFormValid()"
                color="secondary"
                block
                class="mr-4"
                submit
                @click="submit()"
              >
                {{ $vuetify.lang.t('$vuetify.ACTIVATE_ACCOUT') }}
              </v-btn>
            </v-form>
          </div>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'EnforcementOfficerActivation',
  props: {
    email: String,
    uuid: String
  },
  data: () => ({
    password: '',
    repeatPassword: '',
    valid: false
  }),
  computed: {
    ...mapGetters('app', ['error']),
    passwordRules() {
      return [v => !!v || this.$vuetify.lang.t('$vuetify.PASSWORD_IS_REQUIRED')]
    },
    repeatPasswordRules() {
      return [
        v => !!v || this.$vuetify.lang.t('$vuetify.PASSWORD_IS_REQUIRED'),
        v =>
          v === this.password ||
          this.$vuetify.lang.t('$vuetify.PASSWORDS_MUST_MATCH')
      ]
    }
  },
  methods: {
    ...mapActions('enforcement', ['setNewPassword']),
    submit() {
      if (!this.isStrongAndValidPassword(this.password)) {
        this.$store.commit(
          'app/setSnackbar',
          {
            show: true,
            type: 'error',
            message: this.$vuetify.lang.t('$vuetify.PASSWORD_CRITERIA_MISMATCH')
          },
          { root: true }
        )
        return
      }
      this.setNewPassword({
        uuid: this.uuid,
        ps1: this.password,
        ps2: this.repeatPassword,
        this: this
      })
    },
    isFormValid() {
      if (
        this.password &&
        this.password.length > 0 &&
        this.repeatPassword &&
        this.repeatPassword.length > 0 &&
        this.password === this.repeatPassword
      ) {
        this.valid = true
        return true
      }
      this.valid = false
      return false
    },
    isStrongAndValidPassword(password) {
      // Check if password is at least 8 characters long
      if (password.length < 8) {
        return false
      }

      // Has at least one number
      if (!/\d/.test(password)) {
        return false
      }

      // Has at least one capital letter
      if (!/[A-Z]/.test(password)) {
        return false
      }

      return true
    }
  }
}
</script>
